import React, { FC, FormEvent } from 'react';
import PropTypes from 'prop-types';
import { Button, Input } from 'esa-ui-library';
import { Form } from '..';
import { passValidator } from '../..';
import { useStore, useValidator } from '../../../common';

interface ResetFormProps {
	onSubmit: () => void;
}

const PasswordForm: FC<ResetFormProps> = ({ onSubmit }): JSX.Element => {
	const [state, dispatch] = useStore();
	const { password, errors } = state;

	useValidator(password, passValidator, 'PASS_INVALID');

	const onPasswordChange = (val: string) => {
		dispatch('PASS', val);
	};

	const submitHandler = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		onSubmit();
	};

	return (
		<Form errors={errors}>
			<form onSubmit={submitHandler}>
				<Input
					type='password'
					label='Password'
					value={password}
					placeholder='Enter your password here'
					dataId='password-field'
					onChange={onPasswordChange}
				/>
				<Button type='submit' title='Continue' fluid primary disabled={!password} dataId='password-button' />
			</form>
		</Form>
	);
};

PasswordForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
};

export { PasswordForm };
